/* Aurora collection tabs — <aurora-tabs> switches which collection panel is shown. */
(function () {
  class AuroraTabs extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-ct-tab]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-ct-panel]'));
      var self = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { self.activate(tab.getAttribute('data-ct-tab')); });
      });
      if (this.tabs[0]) this.activate(this.tabs[0].getAttribute('data-ct-tab'), true);

      // tab bar — track spans first→last tab, thumb tracks the active tab
      this.bar = this.querySelector('.aurora-ct__bar');
      this.barThumb = this.querySelector('.aurora-ct__bar-thumb');
      if (this.bar) {
        var hostBar = this;
        window.addEventListener('resize', function () { hostBar.positionBar(); });
        window.addEventListener('load', function () { hostBar.positionBar(); });
        requestAnimationFrame(function () { hostBar.positionBar(); });
      }

    }

    activate(index, silent) {
      this.tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-ct-tab') === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach(function (panel) {
        var on = panel.getAttribute('data-ct-panel') === index;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
      // the newly-shown carousel needs its progress recalculated (it was display:none)
      if (!silent) window.dispatchEvent(new Event('resize'));
      this.positionBar();
    }

    positionBar() {
      if (!this.bar || !this.barThumb || !this.tabs.length) return;
      var first = this.tabs[0];
      var last = this.tabs[this.tabs.length - 1];
      var active = null;
      for (var i = 0; i < this.tabs.length; i++) { if (this.tabs[i].classList.contains('is-active')) { active = this.tabs[i]; break; } }
      if (!active) active = first;
      var left = first.offsetLeft;
      var width = last.offsetLeft + last.offsetWidth - left;
      this.bar.style.left = left + 'px';
      this.bar.style.width = width + 'px';
      this.barThumb.style.left = (active.offsetLeft - left) + 'px';
      this.barThumb.style.width = active.offsetWidth + 'px';
    }
  }
  if (!customElements.get('aurora-tabs')) customElements.define('aurora-tabs', AuroraTabs);

  /* carousel progress thumb (per visible panel) */
  function initProgress(wrap) {
    if (wrap.dataset.ctInit) return;
    var slider = wrap.querySelector('[id^="Slider-"]');
    var thumb = wrap.querySelector('.aurora-ct__progress-thumb');
    if (!slider || !thumb) return;
    wrap.dataset.ctInit = '1';
    function update() {
      var max = slider.scrollWidth - slider.clientWidth;
      var pct = Math.min(100, (slider.clientWidth / slider.scrollWidth) * 100);
      thumb.style.width = pct + '%';
      thumb.style.left = (max > 0 ? (slider.scrollLeft / max) * (100 - pct) : 0) + '%';
    }
    slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function allProgress(scope) { (scope || document).querySelectorAll('.aurora-ct__slider-wrap').forEach(initProgress); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { allProgress(); });
  else allProgress();
  document.addEventListener('shopify:section:load', function (e) { allProgress(e.target); });
})();
